import { ILocaleLegacy } from '@locales/interfaces';

/**
 * @deprecated
 * @todo
 * These are legacy translations. Some of them are used silently (come from BE), while others are outdated.
 * Please remove keys if you are 100% sure that they are not used in the project anymore.
 */
export const zh = {
  IBCorporate: '代理公司问卷',
  IBIndividual: '代理 个人问卷',
  MAMIndividual: '个人资管',
  MAMMasterWithLPOA: '个人资管',
  MarkupConfirmation: '加成确认',
  UserCorporate: '企业用户',
  UserIndividual: '个人用户',
  UserJoint: '联名用户',
  account: {
    bankingDetails: '银行卡详细信息',
    createANewAccount: '开立账户',
    register: '注册',
    registerSignInTitle: '已经是会员了？',
  },
  admin: {
    user: {
      fields: {
        isMam: 'Is MAM',
        isSales: 'Is Sales User',
      },
    },
    tabs: {
      tradingSettings: {
        tradingAccountSettings: 'Trading Account Settings',
        setIBCode: 'Set IB Code',
      },
    },
    reports: {
      ftdUtmReport: {
        headerTitle: 'FTD_UTM Report',
        menuTitle: 'FTD_UTM Report',
      },
    },
  },
  adminSocialTrading: {
    title: '跟单社区',
    investorAccountDetails: {
      tradingAccountName: '交易账户姓名',
      balance: '余额',
      login: '登录',
    },
    masterAccountDetails: {
      copyType: '复制类型',
      groupMappingType: 'Group Mapping Type',
      login: '登录',
    },
  },
  backgroundJobs: {
    recurring: {
      title: 'Recurring Jobs',
    },
  },
  bonuses: {
    collectBirthdayGift: '领取您的生日礼物',
    availableTable: {
      bonusSize: '奖金金额',
    },
  },
  errors: {
    shared: {
      recordWasNotFound: '无法找到记录',
    },
    captcha: {
      captchaServerIsUnavailable:
        'Captcha 服务器不可用。请刷新页面并重试。如果问题仍然存在，请通过在线聊天或发送电子邮件至 {{0}} 联系支持人员',
    },
    files: {
      fileWasNotUploaded: 'File was not loaded',
    },
    mam: {
      linkIsInactive: 'Used link is not active',
    },
    trading: {
      profitSharingLimitWasExceeded: '请注意，已超过利润分成的最高限制。 最高限制为 {{0}}%',
      notEnoughMoney:
        '我们深表歉意，但您的交易账户中没有足够的资金。在尝试提款之前，请确保您有足够的可用余额。请注意，除了可用余额外，针对持仓账户有保护政策，还需要参考预付款比例要求。',
    },
    copyTrading: {
      equityIsLessOrEqualZero: '主帐户目前不符合复制条件，请稍后再试',
    },
    securityCode: {
      emptyValue: 'ค输入的安全值（密码或 PIN 码）不能为空或为 null',
      invalidLength: '输入的安全值（密码或 PIN 码）必须包含 {{0}} 个字符',
      invalidMinLength: '输入的安全值（密码或 PIN 码）必须至少包含 {{0}} 个字符',
      invalidMaxLength: '输入的安全值（密码或 PIN 码）不能超过 {{0}} 个字符',
      manyRepeatedValues: '输入的安全值（密码或 PIN 码）不能有超过 {{0}} 个重复字符',
      missingNumericValues: '输入的安全值（密码或 PIN 码）必须包含数字字符',
      containsNumericValues: '输入的安全值（密码或 PIN 码）不能包含任何数字值',
      missingLowerCaseValues: '输入的安全值（密码或 PIN 码）必须包含小写字符',
      containsLowerCaseValues: '输入的安全值（密码或 PIN 码）不能包含任何小写值',
      missingUpperCaseValues: '输入的安全值（密码或 PIN 码）必须包含大写字符',
      containsUpperCaseValues: '输入的安全值（密码或 PIN 码）不能包含任何大写值',
      missingSpecialValues: '输入的安全值（密码或 PIN 码）必须包含特殊字符',
      containsSpecialValues: '输入的安全值（密码或 PIN 码）不能包含任何特殊字符',
      passwordChangeLimit: 'Password change attempts limit is exceeded. Please wait and try again',
    },
    user: {
      accountHasBeenDisabled: '很抱歉给您带来不便，帐户 {{0}} 已被禁用',
      ageIsAboveMaxAllowed: 'W我们不接受任何来自未满{{0}}岁的未成年人与超过{{1}}岁的老年人申请.',
      ageIsUnderMinAllowed: '我们不接受任何来自未满{{0}}岁的未成年',
      cantChangeLanguage: 'Cannot change language',
      fieldIsRequired: '字段 {{0}} 是必需的',
      ibCodeIsIncorrect: 'IB 代码“{{0}}”不正确。 请输入有效的 IB 代码',
      invalidCredentials: '用户名 {{0}} 或者密码无效',
      invalidLengthOfPhoneNumber: '电话号码长度无效，请重试',
      invalidLink: '链接无效',
      invalidPhoneNumberLength: '电话号码长度无效，请重试',
      onlyLatinCharactersAndDigitsAndSpecialSymbolsCanBeUsed:
        'Only latin characters, digits and special symbols can be used for {{0}} field',
      onlyLatinCharactersAndDigitsCanBeUsed: 'Only latin characters and digits can be used for {{0}} field',
      onlyLatinCharactersCanBeUsed: '{{0}} 字段只能使用拉丁字符',
      onlyChineseCharactersCanBeUsed: 'Only chinese characters can be used for {{0}} field',
      personalDataNotEntered: 'Personal data are not entered',
      userCannotBeRestored:
        'Sorry, the record cannot be restored as the email or phone number of this profile is already in use with another profile, please delete the profile with the same email or phone number to restore this one',
      userDoesntExist: '用户 {{0}} 不存在',
      userEmailAlreadyExists: '用户电子邮箱已在系统中注册',
      userPhoneAlreadyExists: '用户手机号码已在系统中注册',
      cantUpdateProfileActualStatus: '无法更新账户 {{0}}，实际状态= {{1}}',
    },
  },
  formats: {
    formatFloat: '{{value, float}}',
    formatMoney: '{{value, money}}',
  },
  forms: {
    dragFile: '或把您的文件拖至此处',
    exportFormat: '导出格式',
    getCode: '获取验证码',
    hide: '隐藏',
    limitMessage: '{{limit}} 个剩余字符',
    resend: '重新发送',
    seconds: '秒',
    show: '显示',
  },
  headerWithBalance: {
    serverTime: '服务器时间',
    failedToFetchServerTime: '无法取得服务器时间',
    view: '查看',
  },
  investors: {
    blackList: '黑名单',
  },
  legal: {
    clientAgreement: '客户协议',
    privacyPolicy: '隐私政策',
  },
  legalTradingPlatform: {
    data: 'Data',
  },
  masterProfile: {
    aboutMaster: '关于操盘大师',
    infoFields: {
      ibCode: 'IB代码',
    },
  },
  masters: {
    fields: {
      masterNickname: '操盘大师昵称',
      rating: '在排行榜中的排名',
    },
  },
  menu: {
    deposit: '存款',
  },
  messages: {
    CopyTrading: {
      InvestorAccountWasLinked: '追随者账户开始复制大师账户“{{MasterAccountName}}”。',
      InvestorAccountWasOpened: '追随者账户已创建。追随者账户开始复制大师账户“{{InvestorAccountName}}”。',
      InvestorAccountWasUnlinked: '追随者账户停止复制大师账户“{{MasterAccountName}}”。',
      MasterAccountWasChanged: '大师帐户已修改。（利润分享={{ProfitSharing}}， 分配方法={{AllocationMethod}}）',
      MasterAccountWasLinked: '追随者账户“{{InvestorAccountName}}”开始复制大师账户。',
      MasterAccountWasOpened: '已创建大师帐户。（利润分享={{ProfitSharing}}， 分配方法={{AllocationMethod}}）',
      MasterAccountWasUnlinked: '追随者账户“{{InvestorAccountName}}”停止复制大师账户。',
    },
  },
  modal: {
    error: '报错',
    notification: '通知',
    ok: '知道了',
  },
  operationHistory: {
    filterName: '搜索',
    placeholder: '请输入',
  },
  pageTitles: {
    admin: {
      financialIdentity: {
        children: {
          cards: 'Cards',
        },
      },
    },
  },
  partnership: {
    salesTitle: '销售',
    ibInfo: {
      detailsTitle: '代理详细信息',
      nextRebatePayment: '下次内返支付',
      statistics: {
        closetTradersReport: {
          type: '类型',
        },
        tradingVolReport: {
          subIb: '子代理',
        },
      },
    },
    ibSettings: {
      referralLinkError: '加点佣不正确！请联系我们的支持以获得正确的方式',
    },
    salesUserInfo: {
      aeCode: '销售编号',
    },
  },
  profile: {
    adult: '我已满18周岁',
    code: '验证码',
    country: '国家',
    documentsUploaded: '已上传文档',
    isAgreeWithTermsAndConditions: '我接受 <0>客户协议</0> 与 <1>隐私政策</1>',
    pleaseValidateAccountToDeposit:
      '您的个人详细信息需要{{brokerName}}合规团队进行核验。在进行入金之前，您需要提交身份证扫描件',
    successChangeDescription: '更改已保存！',
    warningMessage: {
      profileIsBeingVerified: '我们正在对您的个人资料进行审核，请稍候',
    },
  },
  psp: {
    accountsFetchFailErr: '获取账户失败',
    confirmEveryTransaction: '确认每笔交易，入金最多需要24小时',
    deposit: {
      depositForm: {
        accountNameTitle: '账户姓名',
        addressLine2: '地址第2行',
        beneficiaryAccountNumberTitle: '收款人帐号',
        beneficiaryBankHint: '请选择银行卡号',
        beneficiaryBankNameHint: '银行名, 例如 (渣打银行)',
        cardNameTitle: 'Card Name',
        localDepositFileHint: '如果需要，请附上确认付款的文件',
      },
      depositTitle: '存入资金',
      notice: '审核完成后即可入金',
      warnToSubmitPersonalDetails: '如需存款，请提交与身份证信息相符的个人资料',
    },
    localAgentTable: {
      login: '登录',
    },
    operationsFetchFailErr: '无法取得操作',
    operationsTable: {
      documentTitle: '文件',
      operationsTableTitle: '最近操作',
      paymentSystemTitle: '支付系统',
    },
    pluginInfoFetchFailErr: '无法取得插件信息',
    pluginNotFound: '无法找到插件',
    pluginsFetchFailErr: '无法取得插件',
    preAuthorizedBanking: '预授权银行业务',
    qrCodeCryptoNotice: '二维码仅供一次性使用。 请勿在加密应用程序中多次扫描此代码，否则您的付款将被暂停。',
    qrCodeCryptoTitle: '加密应用二维码',
    resentOperationsTitle: '最近操作',
    transfer: {
      transactionDetailsTitle: '交易细节',
      transferForm: {
        amountError: '超过可用转账金额',
        currencyTitle: '货币',
      },
    },
    uploadBankStatementWithBankName: '上传包含您的全名，银行名称和账号的银行对账单',
    uploadPayslip: '上传存款的银行流水',
    uploadYourDocument: '请上传银行对账单以确认存款',
    withdrawal: {
      notice: '审核完成的账户才能提款',
      withdrawalTitle: '提取资金',
      withdrawalForm: {
        bankNameTitle: '银行名称',
        beneficiaryCryptoWalletHint: '一个带有加密货币的钱包号码将被发送到',
        beneficiaryCryptoWalletTitle: '受益人加密钱包',
        confirmTitle: '请确认出金信息',
      },
    },
  },
  settings: {
    docsForm: {
      documentNumberHint: '检查身份证号码是否与照片相符',
      documentTypeHint: '请确保您提供的是清晰地图片或者有效的扫描件',
      uploadedDocumentsTable: {
        docNameTitle: '文件名',
        documentNumber: '文档编号',
        typeTitle: '文件类型',
      },
    },
    profileForm: {
      editProfileTitle: '编辑个人资料',
      proceedToDeposit: '开始入金',
      saveUserSuccessMessage: '用户个人资料保存成功',
      userDetailsErrorMessage: '无法取得用户个人资料',
      verifyPersonalDetails: '确认个人详细信息',
      verifyProfileBtn: '确认个人资料',
    },
  },
  socialTradingModal: {
    copyHint: '您的帐户 {{account}} 将停止复制 Master {{oldMaster}} 并将开始复制 Master {{newMaster}}',
  },
  tradingAccounts: {
    accountDetailsTitle: '交易账户',
    accountHistoryForm: {
      closeTimeTitle: '平仓时间',
    },
    changeTradingAccountName: '更改交易账户姓名',
    connectedAccounts: '关联账户',
    currency: '货币',
    depositForm: {
      amountTitle: '金额',
      errorMessage: '存入资金失败',
      successMessage: '存入资金成功',
    },
    descriptionPlaceholder: '输入对追随者的建议',
    fetchServersErr: '无法取得服务器',
    ibCode: '代理（可选的）',
    notRows: '没有要显示的行',
    openAccountModalSubTitle: '交易最受欢迎的交易品种：外汇、贵金属、差价合约。',
    tradingPlatforms: '交易平台',
    transferForm: {
      title: '转账',
    },
    withdrawForm: {
      amountTitle: '金额',
      errorMessage: '无法保存杠杆',
      successMessage: '提取资金成功',
    },
  },
} satisfies ILocaleLegacy;
